<ng-container *transloco="let t">
  <z-grid-table
    [gridId]="gridId"
    [(rowSelection)]="selectedRow"
    [sorts]="sorts$ | async"
    [filters]="filters$ | async"
    [contextMenuItems]="contextMenuItems$ | async"
    [onLazyLoad]="onLazyLoad"
    [onRowSelect]="onRowSelect"
    dataKey="custid"
    trackByColumn="custid"
    (selectRow)="onSelectRow($event)"
    selectionMode="multiple"
  ></z-grid-table>
</ng-container>
